<script lang="ts">
import { useFileStore } from "@/stores/fileStore";
import { useGlobalStore } from "@/stores/globalStore";
export default {
  setup() {
    const fileStore = useFileStore();
    const globalStore = useGlobalStore();
    return {
      fileStore,
      globalStore,
    };
  },
  data() {
    return {
      activeCategory: "",
      menu: [
        {
          label: "admin.stats",
          to: "/stats",
          direct: true,
        },
        {
          label: "admin.gestion",
          children: [
            { label: "admin.calendar", to: "/calendar" },
            { label: "admin.site", to: "/site-manager" },
            { label: "admin.cluster", to: "/cluster-manager" },
            { label: "admin.gestionRoles", to: "/role-manager" },
            { label: "admin.kitManagement", to: "/kit-manager" },
            {
              label: "admin.photographerManagement",
              to: "/photographer-manager",
            },
            {
              label: "admin.reference-file-upload",
              to: "/reference-file-upload",
            },
            {
              label: "admin.file-upload",
              to: "/file-upload",
            },
          ],
        },
        {
          label: "general-folder-list.title",
          children: [
            { label: "general-folder-list.ALL", to: "/files-list/ALL" },
            {
              label: "general-folder-list.incomplete",
              to: "/folder-list/IN_PROGRESS",
            },
            {
              label: "general-folder-list.NOBODY_RECOGNIZED",
              to: "/files-list/NOBODY_RECOGNIZED",
            },
            {
              label: "general-folder-list.DUPLICATED",
              to: "/folder-list/DUPLICATED",
            },
            {
              label: "general-folder-list.COMPLETED",
              to: "/folder-list/COMPLETED",
            },
            {
              label: "general-folder-list.DISCARDED",
              to: "/files-list/DISCARDED",
            },
            { label: "general-folder-list.ERROR", to: "/files-list/ERROR" },
          ],
        },
        {
          label: "admin.athlete-status",
          to: "/athlete-status",
          direct: true,
        },
        {
          label: "admin.last-actions",
          to: "/last-actions",
          direct: true,
        },
        {
          label: "admin.go-validation",
          to: "/quality-control",
          direct: true,
        },
        {
          label: "admin.go-edition",
          to: "/editor",
          direct: true,
        },
      ],
      dashboardMenu: [
        {
          label: "admin.stats",
          to: "/dashboard",
          direct: true,
        },
        {
          label: "admin.athlete-status",
          to: "/athlete-status",
          direct: true,
        },
        {
          label: "general-folder-list.COMPLETED",
          to: "/folder-list/COMPLETED",
          direct: true,
        },
      ],
      oneChance: false,
    };
  },
  mounted() {
    this.findActiveCategory();
  },
  watch: {
    "$route.path"() {
      this.oneInAMillion();
      this.findActiveCategory();
    },
    "fileStore.status"() {
      this.findActiveCategory();
    },
  },
  methods: {
    oneInAMillion() {
      // Non-security logic: Weak randomness acceptable here
      this.oneChance = Math.random() < 1 / 1000000;
      setTimeout(() => {
        this.oneChance = false;
      }, 4000);
    },
    isActive(routeName: string): string {
      if (this.$route.path === routeName) return "admin-link-active";
      const lastSegment = routeName.split("/").filter(Boolean).pop();
      if (lastSegment === this.fileStore.status) return "admin-link-active";
      return "";
    },
    toggleCategory(label: string) {
      this.activeCategory = this.activeCategory === label ? "" : label;
    },
    findActiveCategory() {
      for (const item of this.menu) {
        if (item.children) {
          if (
            item.children.some((child: any) => this.$route.path === child.to)
          ) {
            this.activeCategory = item.label;
            return;
          }
        }
      }
      for (const item of this.menu) {
        if (item.children) {
          if (
            item.children.some((child: any) => {
              const lastSegment = child.to.split("/").filter(Boolean).pop();
              return lastSegment === this.fileStore.status;
            })
          ) {
            this.activeCategory = item.label;
            return;
          }
        }
      }
    },
    isCategoryActive(item: any): string {
      if (!item.children) return "";
      if (item.children.some((child: any) => this.$route.path === child.to)) {
        return "admin-link-active";
      }
      if (
        item.children.some((child: any) => {
          const lastSegment = child.to.split("/").filter(Boolean).pop();
          return lastSegment === this.fileStore.status;
        })
      ) {
        return "admin-link-active";
      }
      return "";
    },
  },
};
</script>

<template>
  <div class="admin-menu" id="admin-menu">
    <LogoIcon2 class="logo" v-if="oneChance" />
    <LogoIcon class="logo" v-else />
    <div
      v-for="(item, index) in globalStore.isDashboardRole
        ? dashboardMenu
        : menu"
      :key="index"
      class="menu-category"
    >
      <template v-if="item.direct">
        <RouterLink
          :class="['no-router-style', 'admin-menu-link', isActive(item.to)]"
          :to="item.to"
        >
          {{ $t(item.label) }}
        </RouterLink>
      </template>

      <template v-else>
        <div
          class="admin-menu-link category-title"
          :class="isCategoryActive(item)"
          @click="toggleCategory(item.label)"
        >
          {{ $t(item.label) }}
          <div
            class="select-icon-menu"
            :class="[activeCategory === item.label ? 'invert' : '']"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 7 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 3.31565L0.445557 0.0809503C0.341649 -0.0291071 0.175458 -0.0266304 0.0743609 0.0864744C-0.0267402 0.199579 -0.0244617 0.380455 0.0794428 0.490475L3.31695 3.91906C3.41884 4.02698 3.58117 4.02698 3.68305 3.91906L6.92055 0.490475C7.02447 0.380455 7.02674 0.199579 6.92563 0.0864744C6.82455 -0.0266304 6.65837 -0.0291071 6.55445 0.0809503L3.5 3.31565Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div
          v-if="activeCategory === item.label && !globalStore.isDashboardRole"
          class="submenu"
        >
          <RouterLink
            v-for="(subItem, subIndex) in item.children"
            :key="subIndex"
            :class="[
              'no-router-style',
              'admin-menu-link-little',
              isActive(subItem.to),
            ]"
            :to="subItem.to"
          >
            {{ $t(subItem.label) }}
          </RouterLink>
        </div>
      </template>
      <!-- Divider -->
      <div class="menu-divider"></div>
    </div>
    <template v-if="globalStore.isDashboardRole">
     <RouterLink
       :class="['no-router-style', 'admin-menu-link', isActive('/calendar')]"
       to="/calendar"
     >
       {{ $t('admin.calendar') }}
     </RouterLink>
   </template>
  </div>
</template>

<style scoped>
.logo {
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  width: 125px;
}
.admin-menu {
  width: 290px;
  height: 100%;
  background-color: var(--bg3);
  display: flex;
  flex-direction: column;
  padding: 3rem 2rem;
}
.admin-menu-link {
  display: flex;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  color: var(--text-medium-emphasis);
  cursor: pointer;
}
.admin-menu-link-little {
  display: flex;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: initial;
  margin-top: 1.7rem;
  margin-bottom: 1.7rem;
  color: var(--text-medium-emphasis);
  cursor: pointer;
}
.admin-link-active {
  color: var(--factstorylight);
}
.menu-divider {
  height: 1px;
  background-color: var(--hairline);
  margin: 1.5rem 0;
}
.select-icon-menu {
  margin-left: 0.8rem;
  width: 15px;
  height: 15px;
}
.invert {
  transform: rotate(180deg);
}
@media screen and (max-width: 1500px) {
  .admin-menu {
    width: 240px;
    padding: 2rem 1rem;
  }
  .admin-menu-link,
  .admin-menu-link-little {
    font-size: 0.9rem;
    margin-left: 1rem;
  }
  .menu-divider {
    margin: 1.4rem 0;
  }
  .admin-menu-link-little {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
@media screen and (max-height: 900px) {
  .admin-menu {
    width: 240px;
    padding: 1.5rem 0.5rem;
  }
  .admin-menu-link,
  .admin-menu-link-little {
    font-size: 0.8rem;
    margin-left: 0.5rem;
  }
  .menu-divider {
    margin: 1.2rem 0;
  }
}
</style>
